<template>
  <div v-loading="loading">
    <!-- large screen table -->
    <div class="card d-none d-md-block table-header mt-4">
      <div class="flex justify-between">
        <div class="flex">
          <div
            class="mr-2 p-2 px-3 filter cursor-pointer hover:shadow-sm"
            :class="{ 'shadow-sm': sortList }"
            @click="sortList = !sortList"
          >
            <img src="@/assets/images/icons/filter.svg" alt="filter icon" />
          </div>
          <div class="table__search-input-wrapper">
            <span class="pr-2 opacity-50">
              <search-icon />
            </span>
            <input
              type="text"
              class="table__search-input"
              placeholder="Search..."
              v-model="querySearch"
            />
            <img src="@/assets/images/icons/search.svg" alt="search icon" />
          </div>
        </div>
        <router-link v-if="$_isAdmin" :to="{ name: 'AddNewUser' }">
          <primary-button buttonText="Add New User" />
        </router-link>
      </div>
      <div class="responsive-table" id="table-wrapper">
        <table class="custom-table responsive-table border-collapse">
          <thead>
            <tr class="shadow-table rounded-lg">
              <th v-for="opt in options"
              :key="opt+'user'"
              >
              {{ opt.name }} 
            </th>
              <th tabindex="-1">
                <span
                @click="istableOptionsModal = true"
                class="cursor-pointer">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.7">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                        fill="#383F51"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                        fill="#383F51"
                      />
                    </g></svg
                ></span>
              </th>
            </tr>
          </thead>

          <tbody v-if="!loading">
             <tr
              v-for="user in paginatedList"
              class="shadow-sm rounded"
              :key="user.id"
            > 
          <!--  <tr v-for="user in users" class="shadow-sm rounded" :key="user.id"> -->

              <!-- <td></td> -->
              <td v-if="isActive('Name')" class="d-flex align-items-center">
                <span>
                  <img
                    src="/img/profile-img.1677cc27.png"
                    alt="user image"
                    class="mr-2 imgSize"
                /></span>
                <span class=""
                  >{{ user.firstname }} {{ user.middlename }}
                  {{ user.lastname }}
                </span>
              </td>
              <td v-if="isActive('Email')">{{ user.email }}</td>
              <td  v-if="isActive('Function')">{{ user.orgFunction ? user.orgFunction.name : "Nill" }}</td>
              <td v-if="isActive('Role')">
                {{ userRole(user) }}
              </td>
              <!-- <td v-if="isActive('Role')"> {{ user.roleInfo.roleName || '' }}</td> -->
             
              <td v-if="isActive('Phone')">{{ user.mobile_no || '' }}</td>
              <td v-if="isActive('DateCreated')">{{ user.createdAt | formatDate }}</td>
              <td v-if="isActive('UserID')">{{ user.gender || '' }}</td>
              <td
                tabindex="-1"
                @blur="selectedRowId = null"
                class="cursor-pointer"
              >
                <el-dropdown v-if="$_isAdmin">
                  <button>
                    <vertical-ellipsis />
                  </button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item disabled>ACTIONS</el-dropdown-item>
                    <el-dropdown-item>
                      <button class="flex items-center" @click="editUser(user)">
                        <edit-icon />
                        <span class="ml-2">Edit User</span>
                      </button>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <button
                        class="flex items-center"
                        @click="showDeleteModal(user)"
                      >
                        <remove-icon />
                        <span class="ml-2">Delete User</span>
                      </button>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <button
                        class="flex items-center"
                        @click="deactivateUser(user)"
                      >
                        <cancel-icon />
                        <span class="ml-2">Deactivate</span>
                      </button>
                    </el-dropdown-item>
                    <el-dropdown-item hidden>
                      <button
                        class="flex items-center"
                        @click="addUserToGroup(user)"
                      >
                        <accept-icon />
                        <span class="ml-2">Add to Group</span>
                      </button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- <div v-if="!allUsers.length">
          <empty-users-icon />
          <p class="text-center text-sm font-bold" style="color: #FCC210;">
            <svg
              width="22"
              height="23"
              viewBox="0 0 22 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="inline"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11 22.4004C4.92487 22.4004 0 17.4755 0 11.4004C0 5.32526 4.92487 0.400391 11 0.400391C17.0751 0.400391 22 5.32526 22 11.4004C22 17.4755 17.0751 22.4004 11 22.4004ZM11 20.4004C15.9706 20.4004 20 16.371 20 11.4004C20 6.42983 15.9706 2.40039 11 2.40039C6.02944 2.40039 2 6.42983 2 11.4004C2 16.371 6.02944 20.4004 11 20.4004ZM16 10.4004H12V6.40039H10V10.4004H6V12.4004H10V16.4004H12V12.4004H16V10.4004Z"
                fill="#FCC210"
              />
            </svg>
            Start Adding Users
          </p>
        </div> -->
      </div>
    </div>
    <!-- mobile table -->
    <div class="d-md-none">
      <div class="flex flex-row mt-3 custom-card justify-between">
        <div class="flex">
          <div class="mb-0 sm:w-48 sm:mr-2 table__search-input-wrapper">
            <span class="pr-2 opacity-50">
              <search-icon />
            </span>
            <input
              type="text"
              class="table__search-input"
              placeholder="Search..."
              v-model="querySearch"
            />
            <img src="@/assets/images/icons/search.svg" alt="search icon" />
          </div>
        </div>
        <router-link class="" :to="{ name: 'AddNewUser' }">
          <primary-button buttonText="Add" />
        </router-link>
      </div>
      <div
        v-for="(user, i) in paginatedList"
        :key="i"
        class="custom-card flex justify-between my-3 text-xs"
      >
        <div class="col-11">
          <div class="flex row flex-row justify-between grow">
            <div class="my-3 col-7">
              <div class="flex">
                <div><img src="./profile.svg" class="align-top" alt="" /></div>
                <span class="my-auto text-muted ml-2"
                  >Name <br />
                  <span class="font-semibold"
                    >{{ user.firstname }} {{ user.middlename }}
                    {{ user.lastname }}</span
                  >
                </span>
              </div>
            </div>
            <div class="my-3 col col-span-2">
              <div class="flex">
                <div><img src="./profile.svg" class="align-top" alt="" /></div>
                <span class="my-auto text-muted ml-2"
                  >Function <br />
                  <span class="font-semibold">{{
                    user.orgFunction ? user.orgFunction.name : "Nill"
                  }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="flex row flex-row justify-between grow">
            <div class="my-3 col-7">
              <div class="flex">
                <div>
                  <img src="./profile.svg" class="align-top" alt="" />
                </div>
                <span class="my-auto text-muted ml-2"
                  >Email <br />
                  <span class="font-semibold">{{ user.email }}</span>
                </span>
              </div>
            </div>
            <div class="my-3 col">
              <div class="flex">
                <div><img src="./profile.svg" class="align-top" alt="" /></div>
                <span class="my-auto text-muted ml-2"
                  >Role <br />
                  <span class="font-semibold">{{ userRole(user) }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="flex row flex-row justify-between grow">
            <div class="my-3 col-7">
              <div class="flex">
                <div><img src="./profile.svg" class="align-top" alt="" /></div>
                <span class="my-auto text-muted ml-2"
                  >Phone Number <br />
                  <span class="font-semibold">{{ user.mobile_no }}</span>
                </span>
              </div>
            </div>
            <div class="my-3 col">
              <div class="flex">
                <div><img src="./profile.svg" class="align-top" alt="" /></div>
                <span class="my-auto text-muted ml-2"
                  >Date Created <br />
                  <span class="font-semibold">{{
                    user.createdAt | formatDate
                  }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-none">
          <el-dropdown>
            <button>
              <vertical-ellipsis />
            </button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item disabled>ACTIONS</el-dropdown-item>
              <el-dropdown-item>
                <button class="flex items-center" @click="editUser(user)">
                  <edit-icon />
                  <span class="ml-2">Edit User</span>
                </button>
              </el-dropdown-item>
              <el-dropdown-item>
                <button
                  class="flex items-center"
                  @click="showDeleteModal(user)"
                >
                  <remove-icon />
                  <span class="ml-2">Delete User</span>
                </button>
              </el-dropdown-item>
              <el-dropdown-item>
                <button class="flex items-center" @click="deactivateUser(user)">
                  <cancel-icon />
                  <span class="ml-2">Deactivate</span>
                </button>
              </el-dropdown-item>
              <el-dropdown-item hidden>
                <button class="flex items-center" @click="addUserToGroup(user)">
                  <accept-icon />
                  <span class="ml-2">Add to Group</span>
                </button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <pagination
      :total="totalUsers"
      :pageNumber="pageNumber"
      @pageNumber="setNumDisplayLocation"
      @pageSize="pageSize"
    />
    <!-- <add-User-to-group-modal
      :show-modal="isAddToGroupModal"
      @close-modal="isAddToGroupModal = false"
      :userId="selectedUser.id"
    /> -->

    <delete-user-modal ref="deleteUserModal" @user-deleted="onUserDeleted" />

    <user-acces-revoker
      :show-modal="isDeactivateModal"
      @close-modal="isDeactivateModal = false"
      @user-deactivated="getUsers"
      :user="selectedUser"
    />
    <TableOptions :showModal="istableOptionsModal" @close-modal="istableOptionsModal = false"
    :setOptions="setOptions" />
  </div>
</template>

<script>
// import Pagination from "@/components/UI/pagination";
import pagination from "../../../UI/pagination.vue";
// import AddUserToGroupModal from "../Modals/AddUserToGroupModal_";
 import UserAccesRevoker from "../Modals/UserAccesRevoker";
import DeleteUserModal from "../Modals/DeleteUserModal.vue";
import TableOptions from  "../Modals/TableOptions.vue"

export default {
  components: {
    // Pagination,
     UserAccesRevoker,
    // AddUserToGroupModal,
    pagination,
    DeleteUserModal,
    TableOptions
  },
  data() {
    return {
      istableOptionsModal: false,
      selectedRowId: null,
      isDeactivateModal: false,
      isAddToGroupModal: false,
      users: ["name"],
      selectedUser: {},
      selectAllUsers: {},
      loading: false,
      groups: [],
      queryFilter: "",
      querySearch: "",
      toggle: false,
      showModal: false,
      sortList: false,
      totalUsers: 1,
      userPerPage: 10,
      pageNumber: 1,
      options: []
    };
  },
  computed: {
    filteredUsers() {
      return this.filterArray(this.users, this.querySearch);
    },
    lists() {
      return this.sortList
        ? this.filteredUsers
            .map((l) => l)
            .sort((a, b) => {
              var x = a.firstname.toLowerCase();
              var y = b.firstname.toLowerCase();
              return x < y ? -1 : x > y ? 1 : 0;
            })
        : this.filteredUsers;
    },
    startRange() {
      return (this.pageNumber - 1) * Number(this.userPerPage);
    },
    endRange() {
      return this.pageNumber * Number(this.userPerPage);
    },
    paginatedList() {
      return this.lists.filter(
        (item, index) => index >= this.startRange && index < this.endRange
      );
    },
  },
  mounted() {
    this.shouldFetchUsers();
    // this.getUsers();
    // this.shouldFetchGroupNames();
    // this.$on("update-deactivated-users", () => {
    //   alert("just reactived a user");
    //   this.getUsers();
    // });
    // this.$on("user-deactivated", () => {
    //   alert("just reactived a user");
    //   this.getUsers();
    // });
  },
  watch: {
    fetchUsers() {
      this.getUsers();
    },
  },
  methods: {
    isActive(itemID) {
      let findIndex = this.options.findIndex((item) => item.id == itemID)
      return findIndex > -1
    },
    setOptions(options) {
      this.options = options
    },
    userRole(user) {
      // let role = JSON.parse(user.role);
      let role = user.roleInfo;
      // return role != null ? role.roleName : "Unassigned";
      return role != null ? role.roleName : "Unassigned";
    },
    settoOrigin() {
      this.userPerPage = 10;
      this.pageNumber = 1;
    },
    pageSize(val) {
      this.userPerPage = val;
    },
    setNumDisplayLocation(val) {
      this.pageNumber = val;
    },
    async getUsers() {
      try {
         let orgId = localStorage.getItem("organizationId");
         let response = await this.$_getUsers(orgId);
        this.loading = false;

         this.users = response.data.data.users; 
       
        this.totalUsers = this.users.length;
        localStorage.setItem("users", JSON.stringify(this.users));
      } catch (error) {
        this.handleError(error);
        this.loading = false;
        console.log(error);
      }
    },
    editUser(user) {
      console.log(user);
      // localStorage.setItem("userId", user.id);
      // localStorage.setItem("selectedUser", JSON.stringify(user));
      this.$router.push(`/users/editUser/${user.id}`);
    },

    async onUserDeleted(user) {
      this.users.splice(this.users.indexOf(user), 1);
    },
    shouldFetchUsers() {
      // let users = JSON.parse(localStorage.getItem("users"));
      // if (users) {
      //   this.users = users;
      //   this.loading = false;
      // } else {
      this.getUsers();
      // }
    },
    // shouldFetchGroupNames() {
    //   // let groupNames = JSON.parse(localStorage.getItem("groupNames"));
    //   // if (groupNames) {
    //   //   this.groups = groupNames;
    //   // } else {
    //   this.getAllGroupsName();
    //   // }
    // },
    // async getAllGroupsName() {
    //   try {
    //     let response = await this.$_getAllGroupsName();
    //     console.log(response);
    //     this.groups = response.data.findGroup;
    //     localStorage.setItem("groupNames", JSON.stringify(this.groups));
    //   } catch (error) {
    //     this.handleError(error);
    //     console.log(error);
    //   }
    // },
    // addUserToGroup(user) {
    //   this.selectUser(user);
    //   this.isAddToGroupModal = true;
    // },
  
    deactivateUser(user) {
     // this.selectUser(user);
      this.selectedUser = user;
      this.isDeactivateModal = true;
    },
    // showActionOptions(id) {
    //   if (!this.selectedRowId) {
    //     this.selectedRowId = id;
    //   } else {
    //     this.selectedRowId = null;
    //   }
    // },
    showDeleteModal(user) {
      this.$refs.deleteUserModal.showModal(user);
    },
    // showViewRoleModal() {
    //   this.$emit("show-view-role-modal");
    //   this.resetSelectedRow();
    // },
    // resetSelectedRow() {
    //   this.selectedRowId = null;
    // },
    // resetUsers() {
    //   localStorage.removeItem("users");
    // },
  },
};
</script>

<style lang="scss" scoped>
.imgSize {
  width: 30px;
  height: 30px;
}
tr:first-child td:first-child {
  border-top-left-radius: 10px;
}

tr:first-child td:last-child {
  border-top-right-radius: 10px;
}

tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

.table__search-input-wrapper {
  background: #7b858f10;
  width: 20vw;
}

table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}

.actions {
  position: absolute;
  background: #ffffff;
  top: 3rem;
  right: 2rem;
  padding: 0.75rem;
  z-index: 999;
  font-size: 0.9rem;
  width: 10rem;

  background: #ffffff;
  /* Stroke */

  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  span {
    padding-right: 0.25rem;
  }

  > div {
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
  }
}
</style>
